import { BentoGrid, BentoCell, KYCBadge } from "@kj/design-system";

const stubMatches = [
  { id: "m1", name: "미유 / Miyu", city: "Tokyo", interests: ["Stray Kids", "K-drama", "여행"] },
  { id: "m2", name: "아오이 / Aoi", city: "Osaka", interests: ["SEVENTEEN", "독서", "음악"] },
  { id: "m3", name: "사쿠라 / Sakura", city: "Fukuoka", interests: ["aespa", "드라마", "운동"] },
  { id: "m4", name: "유키 / Yuki", city: "Yokohama", interests: ["NewJeans", "한식", "음악"] },
  { id: "m5", name: "히나 / Hina", city: "Kobe", interests: ["IVE", "여행", "K-drama"] },
];

export default function MatchesPage() {
  return (
    <div className="flex flex-col gap-6">
      <header>
        <h2 className="text-2xl font-semibold tracking-tight">오늘의 추천</h2>
        <p className="text-sm text-fg-muted">
          당신의 Hallyu 지수와 취향에 맞춘 5명 · 매일 09:00 갱신
        </p>
      </header>

      <BentoGrid>
        {stubMatches.map((m, i) => (
          <BentoCell
            key={m.id}
            tone={i === 0 ? "primary" : "default"}
            span={i === 0 ? "md" : "sm"}
            height={i === 0 ? "md" : "sm"}
            eyebrow={m.city}
            title={m.name}
          >
            <div className="mt-2 flex items-center gap-2">
              <KYCBadge size="sm" label="Verified" />
              <span className="text-xs text-fg-muted">· 최근 접속 2시간 전</span>
            </div>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {m.interests.map((it) => (
                <span
                  key={it}
                  className="rounded-full bg-white/5 px-2 py-0.5 text-xs text-fg-muted"
                >
                  {it}
                </span>
              ))}
            </div>
            <button
              type="button"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1.5 text-xs font-medium text-white shadow-glass-sm"
            >
              💬 대화 시작
            </button>
          </BentoCell>
        ))}
      </BentoGrid>
    </div>
  );
}
